import http from "@/utils/http";

export function getBranchSchools() {
    return http("/branch_schools");
}

export function getGrades() {
    return http("/grades");
}

export function getFaqs(params) {
    return http(`/faqs`, { params });
}

export function getBanners() {
    return http("/banners");
}

export function getSubscriptionUpgradeDates() {
    return http("/subscription_upgrade_dates");
}

export function verifyStudentCode(data) {
    return http.post("/verify_student_code", data);
}
